import React from 'react';
import { Instagram, Facebook, Youtube } from 'lucide-react';

interface SocialIconProps {
  platform: string;
  size?: number;
  showName?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

export const SocialIcon: React.FC<SocialIconProps> = ({
  platform,
  size = 16,
  showName = false,
  className = '',
  style = {},
}) => {
  const p = platform.toLowerCase();

  let iconNode: React.ReactNode = null;
  let platformClass = '';
  let displayName = platform;

  if (p.includes('instagram')) {
    platformClass = 'platform-instagram';
    displayName = 'Instagram';
    iconNode = <Instagram size={size} />;
  } else if (p.includes('facebook')) {
    platformClass = 'platform-facebook';
    displayName = 'Facebook';
    iconNode = <Facebook size={size} />;
  } else if (p.includes('youtube')) {
    platformClass = 'platform-youtube';
    displayName = 'YouTube';
    iconNode = <Youtube size={size} />;
  } else if (p.includes('pinterest')) {
    platformClass = 'platform-pinterest';
    displayName = 'Pinterest';
    iconNode = (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 0C5.373 0 0 5.372 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738.098.119.112.224.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.631-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12 0-6.628-5.373-12-12-12z"/>
      </svg>
    );
  } else if (p.includes('tiktok')) {
    platformClass = 'platform-tiktok';
    displayName = 'TikTok';
    iconNode = (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
        <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 1 1-5.2-1.74 2.89 2.89 0 0 1 2.31-1.39V9.06a6.34 6.34 0 0 0-5.06 6.18A6.34 6.34 0 0 0 10.76 21.6a6.34 6.34 0 0 0 6.34-6.34V9.61a8.27 8.27 0 0 0 4.82 1.53V7.69a4.86 4.86 0 0 1-2.33-1.00z"/>
      </svg>
    );
  } else {
    platformClass = 'platform-badge';
    displayName = platform;
    iconNode = null;
  }

  return (
    <span
      className={`platform-badge ${platformClass} ${className}`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: showName ? '0.35rem' : '0',
        padding: showName ? '0.2rem 0.5rem' : '0.25rem',
        borderRadius: '6px',
        lineHeight: 1,
        ...style,
      }}
      title={platform}
    >
      {iconNode}
      {showName && <span>{displayName}</span>}
    </span>
  );
};
